import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Column } from '../grid/experimental.grid';

export interface FocusSelectorSortActiveForPerformerGrid {
    column: Column;
}

export const focusSelectorSortActiveForPerformerGrid = createAction<
    ActionType,
    FocusSelectorSortActiveForPerformerGrid
>(ActionType.COACHING_FOCUS_SELECTOR__SORT_ACTIVE_FOR_PERFORMER_GRID);
